import { Button } from '@deckee/deck-hand';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { send, shareArrow } from '../../shared/vector-images';
import styles from './SubmitShare.scss';

const cx = classNames.bind(styles);

const iconShape = (iconName) => {
  switch (iconName) {
    case 'send':
      return send();

    case 'share':
      return shareArrow();

    default:
      return null;
  }
};

const SubmitShare = (props) => {
  const { className, action, disabled, submitting, label, iconName } = props;

  const viewClasses = cx('submit-share', {
    'submit-share--disabled': disabled,
    'submit-share--submitting': submitting,
    [className]: className,
  });

  return (
    <Button
      wide
      onClick={action && (() => action())}
      onKeyDown={action && (() => action())}
      type="submit"
      disabled={disabled}
    >
      {submitting ? 'Submitting...' : label}
    </Button>
  );
};

SubmitShare.propTypes = {
  /** Action for the onClick event */
  action: PropTypes.func,

  /** Changes button label when button in the process of submitting */
  submitting: PropTypes.bool,

  /** Is the button currently disabled */
  disabled: PropTypes.bool,

  /** The text label for the submit button */
  label: PropTypes.string,

  iconName: PropTypes.oneOf([undefined, 'send', 'share']),

  /** Extra classes */
  className: PropTypes.string,
};

SubmitShare.defaultProps = {
  action: undefined,
  submitting: false,
  disabled: false,
  label: 'Continue',
  iconName: undefined,
  className: null,
};

export default SubmitShare;
